import { useState, useEffect, useCallback } from "react";
import { API } from "@/lib/constants";

export function useQuota(user) {
  const [quota, setQuota] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const r = await fetch(`${API}/user/quota`, { credentials: "include" });
      if (r.ok) setQuota(await r.json());
    } catch {
      // ignore
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [user, refresh]);

  return { quota, refresh };
}
